module.exports = __webpack_public_path__ + "static/media/circle icon-3.9b2638f5.png";